/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { FC } from 'react'
import { useModal } from '../../contexts/ModalContext'
import { useNavigate } from 'react-router'
import TaskDetailsModal from './Actions/details/TaskDetailsModal'
import TaskComplete from '../../components/doc-preview/TaskComplete'
import { TASK_ACTIONS } from '../../components/doc-preview/TaskComplete'
import { Task } from './types'

interface TaskTypeLinkProps {
  task: Task
}

/**
 * Task Type Link Component
 *
 * Renders clickable link to view task details, complete modal, or navigates to file view
 */
const TaskTypeLink: FC<TaskTypeLinkProps> = ({ task }) => {
  const { showModal } = useModal()
  const navigate = useNavigate()

  // Find the file object as in legacy logic
  const file =
    task.files && task.files[0]
      ? task.files[0].draftFsi
        ? task.files[0].draftFsi
        : task.files[0].targetFsi
          ? task.files[0].targetFsi
          : task.files[0].sourceFsi
      : null

  const canApproveOrRevert = !!(task.flags?.canApprove || task.flags?.canRevert)

  const onClick = () => {
    if (file && canApproveOrRevert) {
      // Navigate to file view with params (match legacy $state.go)
      navigate(
        `/show-file/${file.id}` +
          `?action=${TASK_ACTIONS.taskComplete}` +
          `&taskId=${task.id}` +
          (file.versionId ? `&version=${file.versionId}` : '') +
          (file.minorVersionId ? `&minorVersion=${file.minorVersionId}` : '')
      )
    } else if (canApproveOrRevert) {
      // Show TaskComplete modal
      showModal(<TaskComplete task={task} isModal={true} type={TASK_ACTIONS.taskComplete} onCancel={() => {}} />)
    } else {
      // Show TaskDetails modal
      showModal(<TaskDetailsModal taskId={task.id} onClose={() => {}} />)
    }
  }

  return (
    <button className="btn btn-link text-left p-0" onClick={onClick} style={{ textDecoration: 'none' }} type="button">
      {task.name}
    </button>
  )
}

export default TaskTypeLink
